import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';

import './ExportOperationReport.scss';

import commonConstant from '../../common/_commonConstant';
import { Loading } from '../../components';
import { Modal, DatePicker, Checkbox, dateYYYYMMDD, dateYYMMDDFormat, Toast } from '../../helpers';
import {
  fetchExportVehicleMovementOperationReport,
  fetchExportRedemptionOperationReport,
  fetchExportMemberMovementOperationReport,
} from '../../actions';

class ExportOperationReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modal': null,
      'toast': null,
      'selectTypeDate': 1,
      'fromDate': new Date(),
      'toDate': new Date(),
      'loading': false,
      'selectFilterCheckbox': {
        'carInOut': {
          ...JSON.parse(commonConstant.defaultFilterVehicleType),
          ...JSON.parse(commonConstant.defaultFilterCustomerType),
        },
        'redeem': {
          ...JSON.parse(commonConstant.defaultFilterVehicleType),
        },
        'member': {
          ...JSON.parse(commonConstant.defaultFilterVehicleType),
          ...JSON.parse(commonConstant.defaultFilterMemberStatus),
        },
      },
    };
    this.toast = createRef();
  }

  componentDidUpdate(prevProps) {
    const { exportOperationReports, match } = this.props;

    if (exportOperationReports && exportOperationReports !== prevProps.exportOperationReports) {
      if (exportOperationReports.status === 200) {
        const element = document.createElement('a');
        element.setAttribute('href', window.URL.createObjectURL(new Blob([exportOperationReports.blob])));
        element.setAttribute('download', `${exportOperationReports.reportType}_operation_report_${match.params.buildingRefNo}_${dateYYMMDDFormat(new Date())}.xlsx`);
        element.setAttribute('id', `dummy-link-${new Date(exportOperationReports.dateTime).getTime()}`);
        document.getElementById('dummy-export').appendChild(element);
        document.getElementById(`dummy-link-${new Date(exportOperationReports.dateTime).getTime()}`).click();

        this.setState({ 'loading': false, 'toast': 'success', 'modal': null });
        return this.toast.current.handleShowToast();
      }

      this.setState({ 'loading': false, 'toast': 'fail', 'modal': null });
      return this.toast.current.handleShowToast();
    }
  }

  handleShowModal = modal => this.setState({
    'modal': modal ? modal : null,
    'selectTypeDate': 1,
    'fromDate': new Date(),
    'toDate': new Date(),
    'selectFilterCheckbox': {
      'carInOut': {
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterCustomerType),
      },
      'redeem': {
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
      },
      'member': {
        ...JSON.parse(commonConstant.defaultFilterVehicleType),
        ...JSON.parse(commonConstant.defaultFilterMemberStatus),
      },
    },
  });

  handleHeaderModal = () => {
    const { modal } = this.state;

    switch (modal) {
      case 'carInOut':
        return 'รายงานความเคลื่อนไหวรถเข้า-ออก';
      case 'redeem':
        return 'สรุปรายงานส่วนลด (redeem)';
      case 'member':
        return 'รายงานสรุปข้อมูลสมาชิก';
      default:
        return null;
    }
  }

  handleBodyModal = () => {
    try {
      const { modal, selectTypeDate, fromDate, toDate, selectFilterCheckbox } = this.state;

      if (!modal) {
        return null;
      }

      return (
        <div className="modal-export-operation-report">
          <div className="box-date">
            <span className="item-label">เลือกช่วงเวลา</span>
            <DatePicker
              id="export-car-in-out-filter-date"
              placeholder="เลือกช่วงเวลา"
              selectType={selectTypeDate}
              fromDate={fromDate}
              toDate={toDate}
              handleSelectDate={this.handleSelectDate}
              datePickerType={modal === 'member' ? 2 : 1}
            />
          </div>
          <div className="box-vehicle-types">
            <div className="item-label">ประเภทรถ</div>
            <div className="box-select-box">
              <Checkbox
                id="filter-car"
                label={selectFilterCheckbox[modal].car.label}
                checked={selectFilterCheckbox[modal].car.select}
                handleSelect={() => this.handleFilterModal(modal, 'car')}
              />
              <Checkbox
                id="filter-motorcycle"
                label={selectFilterCheckbox[modal].motorcycle.label}
                checked={selectFilterCheckbox[modal].motorcycle.select}
                handleSelect={() => this.handleFilterModal(modal, 'motorcycle')}
              />
            </div>
          </div>
          {
            modal === 'carInOut' ?
              <div className="box-customer-type">
                <div className="item-label">ประเภทลูกค้า</div>
                <div className="box-select-box">
                  <Checkbox
                    id="filter-visitor"
                    label={selectFilterCheckbox[modal].visitor.label}
                    checked={selectFilterCheckbox[modal].visitor.select}
                    handleSelect={() => this.handleFilterModal(modal, 'visitor')}
                  />
                  <Checkbox
                    id="filter-member"
                    label={selectFilterCheckbox[modal].member.label}
                    checked={selectFilterCheckbox[modal].member.select}
                    handleSelect={() => this.handleFilterModal(modal, 'member')}
                  />
                </div>
              </div>
              : null
          }
          {
            modal === 'member' ?
              <div className="box-customer-type">
                <div className="item-label">สถานะลูกค้า</div>
                <div className="box-select-box">
                  <Checkbox
                    id="filter-active"
                    label={selectFilterCheckbox[modal].active.label}
                    checked={selectFilterCheckbox[modal].active.select}
                    handleSelect={() => this.handleFilterModal(modal, 'active')}
                  />
                  <Checkbox
                    id="filter-inactive"
                    label={selectFilterCheckbox[modal].inactive.label}
                    checked={selectFilterCheckbox[modal].inactive.select}
                    handleSelect={() => this.handleFilterModal(modal, 'inactive')}
                  />
                  <Checkbox
                    id="filter-expired"
                    label={selectFilterCheckbox[modal].expired.label}
                    checked={selectFilterCheckbox[modal].expired.select}
                    handleSelect={() => this.handleFilterModal(modal, 'expired')}
                  />
                </div>
              </div>
              : null
          }
          <Button className="btn-download btn-primary" id="btn-export-report" onClick={this.handleExportOperationReport}>
            ดาวน์โหลด
          </Button>
        </div>
      );
    } catch (error) {
      return null;
    }
  }

  handleExportOperationReport = () => {
    try {
      const { modal, fromDate, toDate } = this.state;
      document.getElementById('dummy-export').innerHTML = '';

      switch (modal) {
        case 'carInOut':
          this.setState({ 'loading': true });
          return this.props.dispatch(fetchExportVehicleMovementOperationReport(
            this.props.match.params.buildingRefNo,
            fromDate ? dateYYYYMMDD(fromDate) : null,
            toDate ? dateYYYYMMDD(toDate) : null,
            this.handleFilterByType('vehicle-type'),
            this.handleFilterByType('customer-type'),
          ));
        case 'redeem':
          this.setState({ 'loading': true });
          return this.props.dispatch(fetchExportRedemptionOperationReport(
            this.props.match.params.buildingRefNo,
            fromDate ? dateYYYYMMDD(fromDate) : null,
            toDate ? dateYYYYMMDD(toDate) : null,
            this.handleFilterByType('vehicle-type'),
          ));
        case 'member':
          this.setState({ 'loading': true });
          return this.props.dispatch(fetchExportMemberMovementOperationReport(
            this.props.match.params.buildingRefNo,
            fromDate ? dateYYYYMMDD(fromDate) : null,
            this.handleFilterByType('vehicle-type'),
            this.handleFilterByType('member-status'),
          ));
        default:
          return null;
      }
    } catch (error) {
      return null;
    }
  }

  handleFilterByType = type => {
    try {
      const { modal, selectFilterCheckbox } = this.state;
      const sum = [];

      for (const property in selectFilterCheckbox[modal]) {
        if (selectFilterCheckbox[modal][property].type === type && selectFilterCheckbox[modal][property].select) {
          sum.push(selectFilterCheckbox[modal][property].value);
        }
      }

      return sum.join(',');
    } catch (error) {
      return null;
    }
  }

  handleFilterModal = (type, key) => { // handle filter modal (checkbox)
    try {
      return this.setState({
        'selectFilterCheckbox': {
          ...this.state.selectFilterCheckbox,
          [type]: {
            ...this.state.selectFilterCheckbox[type],
            [key]: { ...this.state.selectFilterCheckbox[type][key], 'select': !this.state.selectFilterCheckbox[type][key].select },
          },
        },
      });
    } catch (error) {
      return null;
    }
  }

  handleSelectDate = (fromDate, toDate, selectTypeDate) => this.setState({ fromDate, toDate, selectTypeDate });

  render() {
    const { modal, loading, toast } = this.state;

    return (
      <div className="ExportOperationReport layout-box-page">
        {loading ? <Loading /> : null}
        <div href="" className="dummy-export" id="dummy-export" />
        <div className="box-items">
          <div className="items" onClick={() => this.handleShowModal('carInOut')} id="export-car-in-out">
            <span className="icon icon-car-in-out" />
            <span className="text">รายงานความเคลื่อนไหวรถเข้า-ออก</span>
          </div>
          <div className="items" onClick={() => this.handleShowModal('redeem')} id="export-redeem">
            <span className="icon icon-redeem" />
            <span className="text">สรุปรายงานส่วนลด (redeem)</span>
          </div>
          <div className="items" onClick={() => this.handleShowModal('member')} id="export-member">
            <span className="icon icon-member" />
            <span className="text">รายงานสรุปข้อมูลสมาชิก</span>
          </div>
        </div>
        <Toast
          text={
            toast === 'success' ?
              <span className="text" id="toast-success">
                <span className="icon icon-check" />
                ดาวน์โหลดรายงานสำเร็จ
              </span>
              : toast === 'fail' ?
                <span className="text" id="toast-fail">
                  <span className="icon fas fa-exclamation-circle" />
                  ดาวน์โหลดรายงานไม่สำเร็จ
                </span>
                : null
          }
          id="toast"
          ref={this.toast}
        />
        <Modal
          show={modal ? true : false}
          header={this.handleHeaderModal()}
          handleToggle={() => this.handleShowModal()}
        >
          {this.handleBodyModal()}
        </Modal>
      </div>
    );
  }
}

ExportOperationReport.propTypes = {
  'dispatch': PropTypes.func.isRequired,
  'match': PropTypes.shape({
    'path': PropTypes.string,
    'params': PropTypes.shape({
      'buildingRefNo': PropTypes.string,
    }),
  }),
  'exportOperationReports': PropTypes.shape({
    'status': PropTypes.any,
    'blob': PropTypes.any,
    'dateTime': PropTypes.any,
    'reportType': PropTypes.string,
  }),
};

const mapStateToProps = ({ exportOperationReports }) => ({ exportOperationReports });

export default connect(mapStateToProps)(ExportOperationReport);
